import config from 'config/config'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { initialize } from 'redux-form'
import { confirmationModal } from 'redux/navigation'
import { Dropdown, Icon } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      initialize,
      confirmationModal,
    },
    dispatch
  )
}

class EditDropdown extends React.Component {
  standardItems() {
    const { medium } = this.props
    const { initialize, deleteMedium, confirmationModal } = this.props
    return [
      <Dropdown.Item
        key={0}
        onClick={(event) => {
          event.preventDefault()
          initialize('mediaBrowserEdit', {
            id: medium.id,
            title_de: medium.title_de,
            title_fr: medium.title_fr,
          })
        }}
        icon="pencil"
        text={I18n.t('admin.mediaBrowser.edit')}
      />,
      <Dropdown.Item
        key={1}
        icon="delete"
        text={I18n.t('admin.mediaBrowser.delete')}
        onClick={(event) => {
          event.preventDefault()
          confirmationModal({
            icon: config.icons.delete,
            negative: true,
            title: I18n.t('admin.mediaBrowser.deleteModal.title'),
            text: I18n.t('admin.mediaBrowser.deleteModal.text'),
            button: I18n.t('admin.mediaBrowser.deleteModal.button'),
            confirm: () => {
              deleteMedium(medium.id)
            },
          })
        }}
      />,
    ]
  }

  customItems() {
    const { medium } = this.props
    const { customActions } = this.props
    if (!customActions) return []
    return customActions(medium).map((customAction, index) => (
      <Dropdown.Item
        key={index + 2}
        text={customAction.text}
        disabled={customAction.disabled}
        icon={customAction.icon}
        description={customAction.description}
        onClick={customAction.onClick}
      />
    ))
  }

  render() {
    return (
      <div>
        <Dropdown
          pointing="right"
          icon={null}
          trigger={
            <Icon
              name="ellipsis horizontal"
              inverted
              size="large"
              onClick={(event) => {
                event.preventDefault()
              }}
            />
          }>
          <Dropdown.Menu
            children={this.standardItems().concat(this.customItems())}
          />
        </Dropdown>
      </div>
    )
  }
}

EditDropdown = connect(mapStateToProps, mapDispatchToProps)(EditDropdown)
export default EditDropdown



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/EditDropdown.jsx